<template>
    <div>
      <div v-for="option in options" :key="option.value">
        <b-radio
            :value="value"
            type="is-teal"
            size="is-small"
            :native-value="option.value"
            @input="handleInput"
        >
          {{ option.label }}
        </b-radio>
        <br />
      </div>
    </div>
</template>

<script>
    export default {
      name: 'FlightStopsSelection',
      data() {
          return {
            selectedVal: '',
          }
      },
      props: {
        options: Array,
        value: {},
        size: {
          type: String,
          default: 'is-small'
        }
      },
      methods: {
        handleInput (val) {
          // console.log(val)
          this.selectedVal = val;
          this.$emit('input', val);
        }
      },
      watch:{
        selectedVal: function(){
          this.$emit('input', this.selectedVal);
        }
      }
    }
</script>

<style lang="scss" scoped>
.pding {
  padding: 10px;
}

.label {
  &.is-required {
    &:before {
      content: "*";
      color: red;
      margin-right: 6px;
    }
  }
}


</style>
